import React from "react";
import { Radio } from "@material-ui/core";
import classnames from "classnames";

import {
  TemplateName,
  useFlyerDetailAddPageTemplateOptionStyles,
} from "./flyer-detail-add-page-template-option.styles";
import { FlyerDetailAddPageTemplateOptionProps } from "./flyer-detail-add-page-template-option.props";
import { FlyerDetailAddPageTemplateOptionIcon } from "../flyer-detail-add-page-template-option-icon/flyer-detail-add-page-template-option-icon.component";

export const FlyerDetailAddPageTemplateOption = (props: FlyerDetailAddPageTemplateOptionProps) => {
  const classes = useFlyerDetailAddPageTemplateOptionStyles();

  const icon = (checked: boolean = false) => {
    const iconClasses = classnames({
      [classes.icon]: true,
      [classes.checked]: checked,
    });

    return (
      <FlyerDetailAddPageTemplateOptionIcon
        previewImageUrl={props.template.preview}
        className={iconClasses}
      />
    );
  };

  return (
    <label className={classes.label}>
      <Radio
        tabIndex={-1}
        checkedIcon={icon(true)}
        className={classes.radio}
        disableRipple
        icon={icon()}
        value={props.template.id}
      />
      <TemplateName
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            props.onEnter(props.template.id);
          }
        }}
      >
        {props.template.name}
      </TemplateName>
    </label>
  );
};
